'use client'

import React, { FC, ReactElement } from 'react'
import styles from './CollectionGame.module.css'
import Wallet from '@/utils/wallet'
import { gameEmbed, sameSiteHttpsRedirect } from './message-policy'

import Bitmap from '@/components/bitmap'

const CollectionGame: FC<{ slug: string }> = (props): ReactElement | null => {
	const ref = React.useRef<HTMLIFrameElement>(null)
	const embed = gameEmbed(props.slug)

	React.useEffect(() => {
		const frame = gameEmbed(props.slug)
		if (!frame) return
		const handleMessage = async (event: MessageEvent) => {
			const iframeWindow = ref.current?.contentWindow
			if (!iframeWindow || event.source !== iframeWindow) return
			if (!frame.origins.includes(event.origin)) return

			const data = event.data
			if (!data || typeof data !== 'object') return

			if (data.action === 'sign-message') {
				if (typeof data.message !== 'string') return
				const { success, signature: r } = await Wallet.signMessage(data.message)

				if (success && ref.current?.contentWindow === iframeWindow) {
					iframeWindow.postMessage(
						{
							action: 'sign-message',
							signature: r,
							address: Wallet.getTaprootAddress(),
							walletProvider: Wallet.type()
						},
						event.origin
					)
				}
			} else if (data.action === 'redirect-parent') {
				const dest = sameSiteHttpsRedirect(data.url, window.location.href)
				if (dest) window.location.assign(dest)
			}
		}
		window.addEventListener('message', handleMessage)
		return () => window.removeEventListener('message', handleMessage)
	}, [props.slug])

	if (props.slug === 'bitmap') {
		return (
			<div>
				<Bitmap slug="bitmap" />
			</div>
		)
	}

	if (props.slug === 'natmap') {
		return (
			<div>
				<Bitmap slug="natmap" />
			</div>
		)
	}

	if (embed) {
		const className = embed.layout === 'btc-war' ? styles.btcWarContainer : styles.container
		const iframeClass = embed.layout === 'btc-war' ? styles.btcWarIframe : styles.iframe
		return (
			<div className={className}>
				<iframe
					ref={ref}
					title={embed.title}
					className={iframeClass}
					allow="accelerometer; autoplay; gyroscope"
					src={embed.src}
					height="100%"
					width="100%"
				/>
			</div>
		)
	}

	return null
}

export default CollectionGame
